/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

import type { TracerConfig } from '@opentelemetry/sdk-trace-base';

/**
 * NodeTracerConfig provides an interface for configuring a Node Tracer.
 */
export type NodeTracerConfig = TracerConfig;
